// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { NotifActivation } from './notif-activation'

const COMPONENT_ID = 'armanemaNotifActivation'

export const showArmanemaNotifActivation = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: NotifActivation,
  },
}
